import { render, staticRenderFns } from "./STooltip.vue?vue&type=template&id=01f9b720&scoped=true&"
import script from "./STooltip.vue?vue&type=script&lang=js&"
export * from "./STooltip.vue?vue&type=script&lang=js&"
import style0 from "./STooltip.vue?vue&type=style&index=0&id=01f9b720&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f9b720",
  null
  
)

export default component.exports